import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import restrictedIcon from 'assets/images/backoffice/online-store/restricted.svg';
import { closeGoStoreNotNationWideShippingModal } from 'actions/onlineStore';
import Store from 'store';
import WarningModal from '../WarningModal';
import styles from './GoStoreNotNationWideShippingModal.css';

class GoStoreNotNationWideShippingModal extends React.Component {
  render() {
    const { outletName, showGoStoreNotNationWideShippingModal } = this.props;

    if (!showGoStoreNotNationWideShippingModal) {
      return null;
    }

    return (
      <WarningModal
        backdrop="static"
        onClick={this._handleClick}
        imageSrc={restrictedIcon}
        title="Upload Products for"
        titleBold={outletName}
        text={
          <span className={styles['fs-15']}>
            Oops, you can’t upload any product because your{' '}
            <strong>Standard Shipping option in GoStore</strong> is not
            activated yet.
          </span>
        }
        buttonText="Activate Standard Shipping Now"
        onHide={this._handleHide}
      />
    );
  }

  _handleHide = () => {
    this.props.dispatch(closeGoStoreNotNationWideShippingModal());
  };

  _handleClick = () => {
    this._handleHide();

    const accessToken = Store.get('moka:accessToken');
    window.open(
      `${process.env.GOSTORE_AUTH_URL}?token=${accessToken}`,
      '_blank'
    );
  };
}

function mapStateToProps(state) {
  const {
    outletName,
    channel,
    showGoStoreNotNationWideShippingModal,
  } = state.onlineStore.outletModal;

  return {
    outletName,
    channel,
    showGoStoreNotNationWideShippingModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(GoStoreNotNationWideShippingModal);

export default withRouter(connected);
